import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import n from "deepmerge";
import t from "react";

function e() {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }

  return n.all([].concat(t).filter(function (n) {
    return n;
  }));
}

function o(n, t) {
  var e = {};
  return Object.keys(n).forEach(function (o) {
    t.includes(o) || (e[o] = n[o]);
  }), e;
}

function r(n, t) {
  var e = {};
  return t.forEach(function (t) {
    t in n && (e[t] = n[t]);
  }), e;
}

function i(n, t, e, o) {
  if (!n) return e;
  var r = "string" == typeof t ? t.split(".") : [t];

  for (o = 0; o < r.length && n; o += 1) {
    n = n[r[o]];
  }

  return void 0 === n ? e : n;
}

function u(n, t) {
  return Object.keys(t).reduce(function (e, o) {
    return Object.assign(Object.assign({}, e), _defineProperty({}, n[o] || o, t[o]));
  }, {});
}

var c = function c(n) {
  return 0 === Object.keys(n).length && n.constructor === Object;
};

function f() {
  for (var _len2 = arguments.length, n = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    n[_key2] = arguments[_key2];
  }

  return function (t) {
    n.some(function (n) {
      return null == n || n(t), null == t ? void 0 : t.defaultPrevented;
    });
  };
}

function s(n) {
  return "function" == typeof n;
}

function a(n) {
  for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    t[_key3 - 1] = arguments[_key3];
  }

  return s(n) ? n.apply(void 0, t) : n;
}

var d = function d(n) {
  return n ? "" : void 0;
},
    l = function l(n) {
  return !!n || void 0;
};

function m() {
  return !("undefined" == typeof window || !window.document || !window.document.createElement);
}

var w = m();

function v() {
  return !!m() && Boolean("ontouchstart" in window || window.navigator.maxTouchPoints > 0 || i(window.navigator, "msMaxTouchPoints", 0) > 0);
}

function p(n) {
  return n ? n.ownerDocument || n : document;
}

function g(n) {
  return "IFRAME" === n.tagName;
}

function h(n) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

  var _p = p(n),
      e = _p.activeElement;

  if (!(null == e ? void 0 : e.nodeName)) return null;
  if (g(e) && e.contentDocument) return h(e.contentDocument.body, t);

  if (t) {
    var _n = e.getAttribute("aria-activedescendant");

    if (_n) {
      var _t = p(e).getElementById(_n);

      if (_t) return _t;
    }
  }

  return e;
}

function b(n) {
  var t = h(n);
  if (!t) return !1;
  if (t === n) return !0;
  var e = t.getAttribute("aria-activedescendant");
  return !!e && e === n.id;
}

function y(n) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref.preventScroll,
      _ref$isActive = _ref.isActive,
      e = _ref$isActive === void 0 ? b : _ref$isActive;

  return e(n) ? -1 : (n.focus({
    preventScroll: t
  }), e(n) ? -1 : requestAnimationFrame(function () {
    n.focus({
      preventScroll: t
    });
  }));
}

function E(n) {
  return n.charAt(0).toUpperCase() + n.slice(1);
}

function j(n) {
  return RegExp(/^([a-z][a-z0-9]*)(-[a-z0-9]+)*$/).test(n);
}

function k(n) {
  return t.forwardRef(n);
}

function A(n) {
  if (window.queueMicrotask && "function" == typeof window.queueMicrotask) return window.queueMicrotask(n);
  Promise.resolve().then(n).catch(function (n) {
    return setTimeout(function () {
      throw n;
    });
  });
}

export { l as ariaAttr, f as callAllHandlers, m as canUseDOM, E as capitalize, y as ensureFocus, k as forwardRef, i as get, h as getActiveElement, p as getDocument, b as hasFocus, d as htmlDataAttr, w as isBrowser, g as isFrame, s as isFunction, j as isKebab, c as isObjectEmpty, v as isTouch, e as merge, o as omit, r as pick, A as queueMicrotask, u as renameKeys, a as runIfFunction };